import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "text-large fw-bold mr-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right p-0 mx-3 text-black" }, null, -1)
const _hoisted_4 = { class: "me-2 fw-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right p-0 mx-3 text-black" }, null, -1)
const _hoisted_6 = { class: "me-2 fw-bold" }
const _hoisted_7 = { class: "d-flex flex-column flex-center mt-5" }
const _hoisted_8 = { class: "text-white mb-1" }
const _hoisted_9 = { class: "text-white" }
const _hoisted_10 = { class: "d-flex flex-row-fluid justify-content-center p-10" }
const _hoisted_11 = {
  key: 0,
  class: "list-group",
  id: "list-tab",
  role: "tablist"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-wrapper d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon rounded-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
    /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "1")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "stepper-label" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "stepper-title fs-2" }, "Academico"),
    /*#__PURE__*/_createElementVNode("div", { class: "stepper-desc fw-normal" }, " Información academica ")
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-line h-40px" }, null, -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-wrapper d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon rounded-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
    /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "2")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "stepper-label" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "stepper-title fs-2" }, "Competencia"),
    /*#__PURE__*/_createElementVNode("div", { class: "stepper-desc fw-normal" }, " Datos de competencia ")
  ])
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-line h-40px" }, null, -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "stepper-wrapper d-flex" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "3")
], -1)
const _hoisted_23 = { class: "stepper-label" }
const _hoisted_24 = { class: "stepper-title fs-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-desc fw-normal" }, " Archivos a subir ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-line h-40px" }, null, -1)
const _hoisted_27 = {
  key: 1,
  class: "list-group",
  id: "list-tab",
  role: "tablist"
}
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-wrapper d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon rounded-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
    /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "1")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "stepper-label" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "stepper-title fs-2" }, "Competencia"),
    /*#__PURE__*/_createElementVNode("div", { class: "stepper-desc fw-normal" }, " Datos de competencia ")
  ])
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-line h-40px" }, null, -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "stepper-wrapper d-flex" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "2")
], -1)
const _hoisted_35 = { class: "stepper-label" }
const _hoisted_36 = { class: "stepper-title fs-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-desc fw-normal" }, " Archivos a subir ", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-line h-40px" }, null, -1)
const _hoisted_39 = {
  key: 2,
  class: "step-documentation h-100"
}
const _hoisted_40 = {
  key: 1,
  class: "card h-100"
}
const _hoisted_41 = { class: "card-body" }
const _hoisted_42 = { class: "card-px text-center py-20 my-10" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill fs-5x mb-4 text-primary" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2x fw-bold my-10" }, "Este registro no requiere adjuntar documentación alguna.", -1)
const _hoisted_45 = { class: "text-gray-500 fs-5 fw-semibold mb-13" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = { class: "text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_sAcademic = _resolveComponent("sAcademic")!
  const _component_sCompetition = _resolveComponent("sCompetition")!
  const _component_sOficial = _resolveComponent("sOficial")!
  const _component_sFiles = _resolveComponent("sFiles")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.gblDialogAcrd,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gblDialogAcrd) = $event)),
    class: "bg-light",
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    fullscreen: true
  }, {
    header: _withCtx(({}) => [
      _createVNode(_component_el_page_header, {
        icon: _ctx.ArrowLeft,
        onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gblDialogAcrd = false))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_avatar, {
              size: 32,
              class: "me-3",
              src: _ctx.evento?.logo
            }, null, 8, ["src"]),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.evento?.name), 1),
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.sport?.name), 1),
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString((_ctx.action == 1) ? _ctx.t('register') : ((_ctx.action == 2) ? _ctx.t('edit') : '')), 1)
          ])
        ]),
        _: 1
      }, 8, ["icon"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_container, {
        style: _normalizeStyle(`height:${_ctx.altura - 205}px;`)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, { class: "w-md-300px w-lg-300px w-xl-400px stepper stepper-pills stepper-column stepper-multistep rounded" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "d-flex flex-column h-100 bgi-size-cover bgi-position-center",
                style: _normalizeStyle(`background-image: url(/media/misc/auth-bg.png);`)
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createVNode(_component_el_image, {
                    style: {"width":"195px","height":"254px"},
                    class: "bg-white rounded border p-1 mb-1",
                    src: `${_ctx.url}/uploads/${_ctx.photo?.ruta}`,
                    fit: 'fill'
                  }, null, 8, ["src"]), [
                    [_directive_loading, _ctx.loaderPhoto]
                  ]),
                  _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.rowAcrd?.firstname), 1),
                  _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.rowAcrd?.lastname) + " " + _toDisplayString(_ctx.rowAcrd?.surname), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.typeRegister == 'D')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["stepper-item cursor-pointer", { active: _ctx.activeStep == 0 }]),
                          id: "list-home-list",
                          "data-bs-toggle": "list",
                          disabled: _ctx.activeStep == 0 ? false : true,
                          href: "#list-home",
                          role: "tab",
                          "aria-controls": "list-home"
                        }, _hoisted_15, 10, _hoisted_12),
                        _createElementVNode("div", {
                          class: _normalizeClass(["stepper-item cursor-pointer", { active: _ctx.activeStep == 1 }]),
                          id: "list-profile-list",
                          "data-bs-toggle": "list",
                          href: "#list-profile",
                          role: "tab",
                          "aria-controls": "list-profile",
                          disabled: _ctx.activeStep == 1 ? false : true
                        }, _hoisted_19, 10, _hoisted_16),
                        _createElementVNode("div", {
                          class: _normalizeClass(["stepper-item cursor-pointer", { active: _ctx.activeStep == 2 }]),
                          id: "list-messages-list",
                          disabled: _ctx.activeStep == 2 ? false : true,
                          "data-bs-toggle": "list",
                          href: "#list-messages",
                          role: "tab",
                          "aria-controls": "list-messages"
                        }, [
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.t('documentation')), 1),
                              _hoisted_25
                            ])
                          ]),
                          _hoisted_26
                        ], 10, _hoisted_20)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["stepper-item cursor-pointer", { active: _ctx.activeStep == 0 }]),
                          disabled: _ctx.activeStep == 0 ? false : true,
                          id: "list-profile-list",
                          "data-bs-toggle": "list",
                          href: "#list-profile",
                          role: "tab",
                          "aria-controls": "list-profile"
                        }, _hoisted_31, 10, _hoisted_28),
                        _createElementVNode("div", {
                          class: _normalizeClass(["stepper-item cursor-pointer", { active: _ctx.activeStep == 1 }]),
                          disabled: _ctx.activeStep == 1 ? false : true,
                          id: "list-messages-list",
                          "data-bs-toggle": "list",
                          href: "#list-messages",
                          role: "tab",
                          "aria-controls": "list-messages"
                        }, [
                          _createElementVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.t('documentation')), 1),
                              _hoisted_37
                            ])
                          ]),
                          _hoisted_38
                        ], 10, _hoisted_32)
                      ]))
                ])
              ], 4)
            ]),
            _: 1
          }),
          _createVNode(_component_el_container, null, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_el_main, { class: "pt-0" }, {
                default: _withCtx(() => [
                  (_ctx.typeRegister == 'D')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.activeStep == 0)
                          ? (_openBlock(), _createBlock(_component_sAcademic, {
                              key: 0,
                              ref: "childComponentRef",
                              idacrd: _ctx.rowAcrd?.idacreditation
                            }, null, 8, ["idacrd"]))
                          : _createCommentVNode("", true),
                        (_ctx.activeStep == 1)
                          ? (_openBlock(), _createBlock(_component_sCompetition, {
                              key: 1,
                              ref: "childComponentRef",
                              idacrd: _ctx.rowAcrd?.idacreditation,
                              idevent: _ctx.rowAcrd?.idevent,
                              idsport: _ctx.rowAcrd?.idsport
                            }, null, 8, ["idacrd", "idevent", "idsport"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.activeStep == 0)
                          ? (_openBlock(), _createBlock(_component_sOficial, {
                              key: 0,
                              ref: "childComponentRef",
                              idacrd: _ctx.rowAcrd?.idacreditation,
                              "list-functions": _ctx.listFunctions
                            }, null, 8, ["idacrd", "list-functions"]))
                          : _createCommentVNode("", true)
                      ], 64)),
                  (_ctx.activeStep == _ctx.totalSteps)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        (_ctx.listTypeFile.length > 0)
                          ? (_openBlock(), _createBlock(_component_sFiles, {
                              key: 0,
                              idacrd: _ctx.rowAcrd?.idacreditation,
                              target: 'accreditation'
                            }, null, 8, ["idacrd"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _hoisted_43,
                                  _hoisted_44,
                                  _createElementVNode("p", _hoisted_45, [
                                    _createElementVNode("span", null, [
                                      _createTextVNode("Si el registro no requiere adjuntar documentación "),
                                      _hoisted_46,
                                      _createTextVNode("por favor haga clic en el botón "),
                                      _createElementVNode("b", _hoisted_47, _toDisplayString(_ctx.activeStep ==
                                                _ctx.totalSteps ? 'Guardar' : _ctx.t('next')), 1),
                                      _createTextVNode(".")
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })), [
                [_directive_loading, _ctx.loader]
              ]),
              _createVNode(_component_el_footer, { class: "p-0 m-0 h-auto text-end" }, {
                default: _withCtx(() => [
                  (_ctx.activeStep > 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: _ctx.backStep
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('back')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    type: (_ctx.activeStep == _ctx.totalSteps) ? 'success' : 'primary',
                    onClick: _ctx.getFormData,
                    loading: _ctx.loader
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.activeStep == _ctx.totalSteps ? _ctx.t('save') : _ctx.t('next')), 1)
                    ]),
                    _: 1
                  }, 8, ["type", "onClick", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpened", "onClosed"]))
}